import {
  CandidateRequirementsDTO,
  QuestionKey,
  QuestionRequirementConfigJobRequirements,
  QuestionnaireRequirements,
  RangeValue,
  RequirementField,
} from './Questionnaire.dto';

const QUESTION_KEYS = Object.values(QuestionKey) as QuestionKey[];

const defaultRequirementField = <T>(questionKey: QuestionKey, jobRequirements: T): RequirementField<T> => ({
  question_key: questionKey,
  job_requirements: jobRequirements,
  is_answered: false,
  is_required: false,
});

const keyToDefaultJobRequirements: Record<QuestionKey, boolean | string[] | RangeValue> = {
  [QuestionKey.READY_FOR_JOB_OFFERS]: false,
  [QuestionKey.CERTIFICATES_AND_LICENSES]: [],
  [QuestionKey.SALARY]: { min: 0, max: 0 },
  [QuestionKey.SHIFTS]: [],
  [QuestionKey.AVAILABLE_DAYS]: [],
  [QuestionKey.LIMITATIONS_AND_PREFERENCES]: [],
  [QuestionKey.WORKING_HOURS_PER_WEEK]: { min: 0, max: 0 },
  [QuestionKey.LANGUAGES]: [],
};

export function questionnaireRequirementsToCandidateRequirements(
  requirements: QuestionnaireRequirements,
): CandidateRequirementsDTO {
  const result: Record<QuestionKey, RequirementField<QuestionRequirementConfigJobRequirements>> = {} as Record<
    QuestionKey,
    RequirementField<QuestionRequirementConfigJobRequirements>
  >;

  for (const key of QUESTION_KEYS) {
    const config = requirements[key];
    const defaultJobReqs = keyToDefaultJobRequirements[key];

    if (config) {
      const jobRequirements = config.job_requirements;
      result[key] = {
        ...defaultRequirementField(key, jobRequirements),
        job_requirements: jobRequirements,
        is_required: config.is_required,
      };
    } else {
      result[key] = defaultRequirementField(key, defaultJobReqs);
    }
  }

  return result as CandidateRequirementsDTO;
}

export function candidateRequirementsToQuestionnaireRequirements(
  dto: CandidateRequirementsDTO,
): QuestionnaireRequirements {
  const result: QuestionnaireRequirements = {};

  for (const key of QUESTION_KEYS) {
    const field = dto[key];
    if (field?.job_requirements !== undefined && field?.job_requirements !== null) {
      result[key] = {
        job_requirements: field.job_requirements,
        is_required: field.is_required ?? false,
      };
    }
  }

  return result;
}
